import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../services/api";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    setOpen(false);
    navigate("/login");
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        setUser(null);
        return;
      }
      try {
        const res = await API.get("/auth/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(res.data);
      } catch (err) {
        console.error(err);
        setUser(null);
      }
    };
    fetchUser();
  }, [token]);

  const displayName = user?.username || user?.email?.split("@")[0] || "User";

  return (
    <div className="navbar">
      {/* Logo */}
      <div className="navbar-logo" onClick={() => navigate("/dashboard")}>
        <img src="/logo.png" alt="Creator Yard" className="navbar-logo-img" />
        <span className="navbar-logo-text">
          Creator <span className="highlight">-Intel</span>
        </span>
      </div>

      {/* Navigation */}
      <div className="navbar-links">
        {user ? (
          <>
            
            <div className="user-dropdown">
              <div className="user-toggle" onClick={() => setOpen(!open)}>
                👤 {displayName}
              </div>
              {open && (
                <div className="dropdown-menu">
                  <div className="dropdown-item" onClick={() => navigate("/studio")}>Profile</div>
                  {user?.is_admin && (
                    <>
                      
                    </>
                  )}
                  <div className="dropdown-item logout" onClick={handleLogout}>🚪 Logout</div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="auth-buttons">
            <Link to="/login" className="nav-link">Login</Link>
            <Link to="/signup" className="signup-btn">Signup</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
